import angular from "angular";
import {
  machinePartsComponentOptions,
  vsComponentName as machinePartsComponentName,
} from "./components/machineParts";

export const vsModuleName = "SlotTrak.Parts.Machines";

angular
  .module(vsModuleName, ["SlotTrak.Machines", "SlotTrak.Parts"])
  .component(machinePartsComponentName, machinePartsComponentOptions);
